import { c as _c } from "react-compiler-runtime";
import { useParams } from 'quartz-routing/react-router';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { PublicShareView, LocaleProvider, ShareableAsset, useIsMobile, adaptEngagementDetails, adaptRecording, adaptTranscript, adaptSummary, adaptNotes } from 'external-sharing-components';
import { useValidateTokenQuery, useGetEngagementDetailsQuery, useGetNotesQuery, useGetRecordingQuery, useGetTranscriptQuery, useGetSummaryQuery } from '../../__generated__/chirp/com/hubspot/universal/recording/review/be/rpc/UniversalRecordingReviewExternalRpc.hooks';
import { na1 } from 'hubspot-url-utils/hublets-next';
import { ExpiredOrInvalidPage } from './ExpiredOrInvalidPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function extractErrorType(error) {
  var _cause;
  return error === null || error === void 0 || (_cause = error.cause) === null || _cause === void 0 || (_cause = _cause.cause) === null || _cause === void 0 ? void 0 : _cause.errorType;
}
function toUrlHublet(hublet) {
  return hublet.toLowerCase().replaceAll('_', '');
}
function getCurrentUrlHublet() {
  const match = window.location.hostname.match(/^app-(\w+)\./);
  return match ? match[1] : na1;
}
function SharePageContent(t0) {
  const $ = _c(68);
  const {
    accessToken
  } = t0;
  const isMobile = useIsMobile();
  let t1;
  if ($[0] !== accessToken) {
    t1 = {
      variables: {
        accessToken
      }
    };
    $[0] = accessToken;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: validateData,
    error: validateError
  } = useValidateTokenQuery(t1);
  const responseHublet = validateData === null || validateData === void 0 ? void 0 : validateData.hublet;
  let t2;
  if ($[2] !== responseHublet) {
    t2 = typeof responseHublet === "string" && toUrlHublet(responseHublet) !== getCurrentUrlHublet();
    $[2] = responseHublet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const needsHubletRedirect = t2;
  const tokenIsValid = validateData !== undefined && validateError === undefined && !needsHubletRedirect;
  let t3;
  if ($[4] !== (validateData === null || validateData === void 0 ? void 0 : validateData.includedAssets)) {
    var _validateData$include;
    t3 = (_validateData$include = validateData === null || validateData === void 0 ? void 0 : validateData.includedAssets) !== null && _validateData$include !== void 0 ? _validateData$include : [];
    $[4] = validateData === null || validateData === void 0 ? void 0 : validateData.includedAssets;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const includedAssets = t3;
  let t4;
  if ($[6] !== includedAssets) {
    t4 = includedAssets.includes("VIDEO_RECORDING") || includedAssets.includes("AUDIO_RECORDING");
    $[6] = includedAssets;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const hasRecordingAsset = t4;
  let t5;
  if ($[8] !== includedAssets) {
    t5 = includedAssets.includes("TRANSCRIPT");
    $[8] = includedAssets;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const hasTranscriptAsset = t5;
  let t6;
  if ($[10] !== includedAssets) {
    t6 = includedAssets.includes("AI_SUMMARY");
    $[10] = includedAssets;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const hasSummaryAsset = t6;
  let t7;
  if ($[12] !== accessToken) {
    t7 = {
      accessToken
    };
    $[12] = accessToken;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = !tokenIsValid;
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = {
      variables: t7,
      skip: t8
    };
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const {
    data: engagementData
  } = useGetEngagementDetailsQuery(t9);
  let t10;
  if ($[17] !== accessToken) {
    t10 = {
      accessToken
    };
    $[17] = accessToken;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = !tokenIsValid;
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = {
      variables: t10,
      skip: t11
    };
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const {
    data: notesData
  } = useGetNotesQuery(t12);
  let t13;
  if ($[22] !== accessToken) {
    t13 = {
      accessToken
    };
    $[22] = accessToken;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = !tokenIsValid || !hasRecordingAsset;
  let t15;
  if ($[24] !== t13 || $[25] !== t14) {
    t15 = {
      variables: t13,
      skip: t14
    };
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const {
    data: recordingData
  } = useGetRecordingQuery(t15);
  let t16;
  if ($[27] !== accessToken) {
    t16 = {
      accessToken
    };
    $[27] = accessToken;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const t17 = !tokenIsValid || !hasTranscriptAsset;
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = {
      variables: t16,
      skip: t17
    };
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  const {
    data: transcriptData
  } = useGetTranscriptQuery(t18);
  let t19;
  if ($[32] !== accessToken) {
    t19 = {
      accessToken
    };
    $[32] = accessToken;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  const t20 = !tokenIsValid || !hasSummaryAsset;
  let t21;
  if ($[34] !== t19 || $[35] !== t20) {
    t21 = {
      variables: t19,
      skip: t20
    };
    $[34] = t19;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  const {
    data: summaryData
  } = useGetSummaryQuery(t21);
  if (needsHubletRedirect && typeof responseHublet === "string") {
    window.location.replace(`https://app-${toUrlHublet(responseHublet)}.hubspotrecap.com/share/${accessToken}`);
    return null;
  }
  if (validateError) {
    let t22;
    if ($[37] !== validateError) {
      t22 = extractErrorType(validateError);
      $[37] = validateError;
      $[38] = t22;
    } else {
      t22 = $[38];
    }
    let t23;
    if ($[39] !== t22) {
      t23 = /*#__PURE__*/_jsx(ExpiredOrInvalidPage, {
        errorType: t22
      });
      $[39] = t22;
      $[40] = t23;
    } else {
      t23 = $[40];
    }
    return t23;
  }
  let t22;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = new Set(Object.values(ShareableAsset));
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  const knownAssetValues = t22;
  let t23;
  if ($[42] !== (validateData === null || validateData === void 0 ? void 0 : validateData.includedAssets)) {
    var _validateData$include2;
    let t24;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = asset => typeof asset === "string" && knownAssetValues.has(asset);
      $[44] = t24;
    } else {
      t24 = $[44];
    }
    t23 = new Set(((_validateData$include2 = validateData === null || validateData === void 0 ? void 0 : validateData.includedAssets) !== null && _validateData$include2 !== void 0 ? _validateData$include2 : []).filter(t24));
    $[42] = validateData === null || validateData === void 0 ? void 0 : validateData.includedAssets;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  const selectedAssets = t23;
  let t24;
  if ($[45] !== engagementData) {
    t24 = engagementData ? adaptEngagementDetails(engagementData) : undefined;
    $[45] = engagementData;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  const meetingDetails = t24;
  let t25;
  if ($[47] !== recordingData) {
    t25 = recordingData ? adaptRecording(recordingData) : undefined;
    $[47] = recordingData;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  const recording = t25;
  let t26;
  if ($[49] !== transcriptData) {
    t26 = transcriptData ? adaptTranscript(transcriptData) : undefined;
    $[49] = transcriptData;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  const transcript = t26;
  let t27;
  if ($[51] !== summaryData) {
    t27 = summaryData ? adaptSummary(summaryData) : undefined;
    $[51] = summaryData;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  const recapHtml = t27;
  let t28;
  if ($[53] !== notesData) {
    t28 = notesData ? adaptNotes(notesData) : undefined;
    $[53] = notesData;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  const senderNotes = t28;
  const t29 = isMobile ? "400" : "600";
  let t30;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = /*#__PURE__*/_jsx(Text, {
      typography: "heading-200",
      color: "text-core-subtle",
      children: "HubSpot"
    });
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t29) {
    t31 = /*#__PURE__*/_jsx(Flex, {
      padding: "400",
      paddingInlineStart: t29,
      children: t30
    });
    $[56] = t29;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] !== meetingDetails || $[59] !== recapHtml || $[60] !== recording || $[61] !== selectedAssets || $[62] !== senderNotes || $[63] !== transcript) {
    t32 = /*#__PURE__*/_jsx(PublicShareView, {
      selectedAssets: selectedAssets,
      meetingDetails: meetingDetails,
      senderNotes: senderNotes,
      recording: recording,
      transcript: transcript,
      recapHtml: recapHtml
    });
    $[58] = meetingDetails;
    $[59] = recapHtml;
    $[60] = recording;
    $[61] = selectedAssets;
    $[62] = senderNotes;
    $[63] = transcript;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== t31 || $[66] !== t32) {
    t33 = /*#__PURE__*/_jsxs(LocaleProvider, {
      children: [t31, t32]
    });
    $[65] = t31;
    $[66] = t32;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  return t33;
}
export function SharePage() {
  const $ = _c(3);
  const {
    accessToken
  } = useParams();
  if (!accessToken) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = /*#__PURE__*/_jsx(ExpiredOrInvalidPage, {
        errorType: "INVALID_TOKEN"
      });
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== accessToken) {
    t0 = /*#__PURE__*/_jsx(NavMarker, {
      name: "SHARE_PAGE_LOAD",
      children: /*#__PURE__*/_jsx(SharePageContent, {
        accessToken: accessToken
      })
    });
    $[1] = accessToken;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}